import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';

export type BadgeVariant = 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info';

const variantClass: Record<BadgeVariant, string> = {
  neutral: 'badge-neutral',
  brand: 'badge-brand',
  success: 'badge-success',
  warning: 'badge-warning',
  danger: 'badge-danger',
  info: 'badge-info',
};

interface BadgeProps {
  variant?: BadgeVariant;
  className?: string;
  children: ReactNode;
}

export const Badge = ({ variant = 'neutral', className, children }: BadgeProps) => (
  <span className={cn(variantClass[variant], className)}>{children}</span>
);
